import RegionSkinProductSelect from "@core-components/regionSelector/select/RegionSkinProductSelect";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import type { AppRegion } from "@core-types/region.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";

interface SkinProductRegionSelectorProps {
  region: AppRegion;
  onRegionChange: (value: AppRegion) => void;
  availableRegions?: AppRegion[];
}

export const SkinProductRegionSelector = ({
  region,
  onRegionChange,
  availableRegions,
}: SkinProductRegionSelectorProps) => {
  const { t } = useAppTranslation("pages.skins.skinProducts");
  const { allRegions } = useAppRegion();

  return (
    <>
      <SSHeadline
        props={{
          stack: { align: "start" },
          title: {
            fz: 15,
          },
        }}
      >
        <SSWhiteText>{t("selectRegion")}</SSWhiteText>
      </SSHeadline>
      <RegionSkinProductSelect
        availableRegion={availableRegions}
        region={region}
        regions={allRegions}
        onRegionChange={onRegionChange}
      />
    </>
  );
};
